import { Injectable } from '@angular/core';
import { Observable, tap, catchError, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ChatbotMessage } from '@types';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private isProcessingMessage = false;
  private backendEndpoint = `${environment.backendUrl}/query`;
  constructor(private http: HttpClient) {}

  handleAnswer(queryPayload: ChatbotMessage): Observable<ChatbotMessage> {
    if (this.isProcessingMessage) {
      return new Observable();
    }

    this.isProcessingMessage = true;
    return this.http
      .post<ChatbotMessage>(this.backendEndpoint, { text: queryPayload.question })
      .pipe(
        tap(() => {
          this.isProcessingMessage = false;
        }),
        catchError((error) => {
          console.error('Error in handleAnswer:', error);
          this.isProcessingMessage = false;
          return of({
            question: queryPayload.question,
            query: '',
            result: [],
            columns: [],
            status: {
              status_code: error?.status || 500,
              message: 'Error',
              detail: error?.message || 'An error occurred. Please try again.'
            }
          } as ChatbotMessage);
        })
      );
  }
}
